module.exports = __webpack_public_path__ + "img/T703.cacd10ce.jpg";